export function loadBase64Img (url) {
  return new Promise(resolve => {
    let img = new Image()
    img.crossOrigin = 'Anonymous'
    img.src = url
    img.onload = function () {
      resolve(getBase64Image(img))
    }
    // img.setAttribute('crossOrigin', 'anonymous')
  })
}

export function loadImg (url) {
  return new Promise(resolve => {
    const img = new Image()
    img.onload = function () {
      resolve(img)
    }
    img.src = url
  })
}

export function getBase64Image (img) {
  let canvas = document.createElement('canvas')
  canvas.width = img.width
  canvas.height = img.height
  let ctx = canvas.getContext('2d')
  ctx.drawImage(img, 0, 0, img.width, img.height)  // 绘制相同图片
  return canvas.toDataURL('image/png') // 转换成base64数据
}